import ENDPOINTS, { ACCREDITATION_SERVICE_ENDPOINTS, APP_USER_SERVICE_ENDPOINTS, ENDPOINTS_SEGMENTS } from '../../constants/endpoints';
import {
  ICreateUpdateAccountParams,
  IDisabilitiesCategoriesApiResponse,
  ILoginAPIResponse,
  ILoginParams,
  IResendOtpParams,
  IUpdateAccountWithEmailParams,
  IUpdatePasswordParams,
  IValidateEmailOtpParams,
  IValidateFormSessionTokenParams,
} from './IAppUser';
import Api from '../../api';
import { FixMeLater } from '../../temporary-types';
import { IForgotPasswordParams, IValidateForgotPassword } from './IAppUser';
import { APP_TYPE } from '../../views/accounts/constant';
import { IMyFormMappingParams, IPaginationResponse, IRequestPaginationParam } from '../../interfaces/IPagination';
import { IMyFormsApiResponse } from '../../views/myForms/IMyForms';
import { FILE_UPLOAD_DIRNAME } from '../../components/Inputs/InputFileUploadSingle/file-upload-constants';

export const authenticateUser = (params: ILoginParams): Promise<ILoginAPIResponse> => {
  const url = `${APP_USER_SERVICE_ENDPOINTS.USER_LOGIN}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };

  const response: Promise<ILoginAPIResponse> = Api.post(url, payload);
  return response;
};

export const craeteAccount = (params: ICreateUpdateAccountParams): Promise<FixMeLater> => {
  const url = `${ENDPOINTS.CREATE_ACCOUNT}`;
  const payload = {
    ...params,
  };
  const response: Promise<FixMeLater> = Api.post(url, payload);
  return response;
};

export const updateAccount = (params: ICreateUpdateAccountParams | IUpdateAccountWithEmailParams): Promise<FixMeLater> => {
  const url = `${ACCREDITATION_SERVICE_ENDPOINTS.ACCOUNTS}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };
  const response: Promise<FixMeLater> = Api.patch(url, payload);
  return response;
};

export const updateAccountWithEmail = (params: IUpdateAccountWithEmailParams): Promise<FixMeLater> => {
  const url = `${ACCREDITATION_SERVICE_ENDPOINTS.ACCOUNTS}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };
  const response: Promise<FixMeLater> = Api.put(url, payload);
  return response;
};

export const validateEmailOtp = (params: IValidateEmailOtpParams): Promise<FixMeLater> => {
  const url = `${ENDPOINTS.EMAIL_OTP_VALIDATION}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };
  const response: Promise<FixMeLater> = Api.post(url, payload);
  return response;
};

export const ResendOtp = (params: IResendOtpParams): Promise<FixMeLater> => {
  const url = `${APP_USER_SERVICE_ENDPOINTS.RESEND_OTP}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };

  const response: Promise<FixMeLater> = Api.post(url, payload);
  return response;
};

export const forgotPassword = (params: IForgotPasswordParams): Promise<FixMeLater> => {
  const url = `${APP_USER_SERVICE_ENDPOINTS.FORGOT_PASSWORD}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };
  const response: Promise<FixMeLater> = Api.post(url, payload);
  return response;
};

export const validateForgotPassword = (params: IValidateForgotPassword): Promise<FixMeLater> => {
  const url = `${APP_USER_SERVICE_ENDPOINTS.VALIDATE_FORGOT_PASSWORD}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };
  const response: Promise<FixMeLater> = Api.post(url, payload);
  return response;
};

export const getAccountDetails = (): Promise<FixMeLater> => {
  const url = `${ACCREDITATION_SERVICE_ENDPOINTS.ACCOUNTS}`;

  const response: Promise<FixMeLater> = Api.get(url);
  return response;
};

export const updatePassword = (params: IUpdatePasswordParams): Promise<FixMeLater> => {
  const url = `${APP_USER_SERVICE_ENDPOINTS.UPDATE_PASSWORD}`;
  const payload = {
    appType: APP_TYPE,
    ...params,
  };
  const response: Promise<FixMeLater> = Api.put(url, payload);
  return response;
};

export const fetchMyForms = (params: IRequestPaginationParam): Promise<IPaginationResponse<IMyFormsApiResponse>> => {
  const url = `${ENDPOINTS.MY_FORMS}`;

  const response = Api.get(url, params);
  return response;
};

export const createMyFormMapping = (params: IMyFormMappingParams): Promise<FixMeLater> => {
  const url = `${ENDPOINTS.MY_FORMS}`;

  const response = Api.post(url, params);
  return response;
};

export const validateFormSessionTokenApi = (tenantId: string, params: IValidateFormSessionTokenParams): Promise<FixMeLater> => {
  const url = `${ENDPOINTS.VALIDATE_FORM_SESSION_TOKEN.replace(ENDPOINTS_SEGMENTS.TENANT_ID, tenantId).replace(ENDPOINTS_SEGMENTS.FORM_SESSION_TOKEN, params.sessionToken)}`;

  const response = Api.post(url, params);
  return response;
};


export const getDisabilitiesCategoriesApi = (): Promise<IDisabilitiesCategoriesApiResponse[]> => {
  const url = `${ENDPOINTS.GET_DISABILITIES_CATEGORIES}`;

  const response = Api.get(url);
  return response;
};


export const uploadFile = (file:File) => {
  const url = `${ENDPOINTS.FILE_UPLOAD_API.replace(
  ENDPOINTS_SEGMENTS.FILE_UPLOAD_DIRNAME,
  FILE_UPLOAD_DIRNAME,
)}`;

  const formData = new FormData();
  formData.append('file', file);

  const response = Api.post(url, formData);
  return response;
};